import { useState } from "react";
import { PhoneCall, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { darkInputCls, SelectField } from "./Fields";

const TIMES = ["Anytime", "Morning (9am – 12pm)", "Afternoon (12pm – 4pm)", "Evening (4pm – 8pm)"];

export default function CallbackForm() {
  const [form, setForm] = useState({ name: "", mobile: "", preferred_time: "Anytime" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/callbacks", form);
      setDone(true);
      toast.success("Callback requested. We'll call you soon.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return <p data-testid="callback-success" className="rounded-2xl border border-mint/30 bg-mint/10 p-6 text-sm text-mint">Thank you, {form.name}. A Quantora specialist will call you at your preferred time.</p>;
  }

  return (
    <form onSubmit={submit} data-testid="callback-form" className="grid gap-4">
      <input required minLength={2} placeholder="Your name" className={darkInputCls} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="callback-name-input" aria-label="Your name" />
      <input required type="tel" pattern="[+0-9 ]{7,20}" placeholder="Mobile number" className={darkInputCls} value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} data-testid="callback-mobile-input" aria-label="Mobile number" />
      <SelectField dark label="Preferred time" id="cb-time" value={form.preferred_time} onChange={(v) => setForm({ ...form, preferred_time: v })} options={TIMES} testid="callback-time-select" />
      <button type="submit" disabled={loading} data-testid="callback-submit-btn"
        className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-3.5 text-sm font-semibold text-navy transition-[transform,background-color] hover:-translate-y-0.5 hover:bg-[#e2c27f] disabled:opacity-60">
        {loading ? <Loader2 size={16} className="animate-spin" /> : <PhoneCall size={16} />} Request a Callback
      </button>
    </form>
  );
}
